import { AppStoreDownloadButton } from '@/components/app-store-download-button'
import { PlayStoreDownloadButton } from '@/components/play-store-download-button'
import { T } from '@/components/t'

export const PricingDownload = () => {
    return (
        <div className="flex w-full max-w-[1040px] flex-col justify-center gap-xl rounded-2xl bg-bg-brand p-2xl md:p-3xl">
            <T h1 t="pricing.cta" className="text-center text-h2 md:text-h1" />
            <div className="flex justify-center gap-m">
                <AppStoreDownloadButton />
                <PlayStoreDownloadButton />
            </div>
        </div>
    )
}
